import React from 'react'
import Award from '../Award/Award'

const OOSSemi = (props) => {
  const awardProps = {
    beginLabel: 'You’re eligible for the Arizona Tuition Award',
    beginAmount: 'Up to $20,000* per academic year',
    fourYear: 'Four-Year Total',
    bonusAward: 'Plus, you’ll receive a bonus award of',
    additionalSemi: '$1,000 per academic year',
    additionalFinalLabel: 'which will be increased to',
    additionalFinal: '$3,000 per academic year if you are named a National Merit Finalist',
  }

  return (
    <div className="award-info">
      <div>
        <Award {...awardProps} />
        <span className="subject">Subject to available funding.</span>{' '}
      </div>
      <div className="award-opportunities">
        <p>
          To take advantage of the opportunities we’re presenting to you, all you have to do is
          formally submit your application for admission. Then, be sure to visit{' '}
          <a
            id="next-steps-center"
            className="blueBrand"
            target="_blank"
            href="https://nextsteps.arizona.edu/nextsteps"
          >
            nextsteps.arizona.edu
          </a>{' '}
          to make things official. Also, keep in mind…
        </p>
        <br />
        <p>
          <span className="red-bar">— </span> You may also be eligible for additional financial aid
          and scholarships from individual University of Arizona colleges or departments.
        </p>
        <br />
        <p>
          <span className="red-bar">— </span> To remain eligible for your maximum award amount,
          please complete your undergraduate application by December 2, 2024.
        </p>
        <br />
        <p>
          <span className="red-bar">— </span> If you have any questions, please contact the Office
          of Admissions at{' '}
          <a
            className="font-color-arizona-blue"
            href="mailto:admissions@arizona.edu"
            target="_blank"
          >
            admissions@arizona.edu
          </a>{' '}
          or{' '}
          <a href="tel:+15206213237" className="font-color-arizona-blue" target="_blank">
            (520) 621-3237
          </a>
          .
        </p>
        <br />
        <p className="italic">
          *Arizona Tuition Awards are determined by your core, unweighted GPA through your sixth
          semester of high school. To review the amount you qualify for, review our{' '}
          <a
            id="arizona-tuition-award-merit-chart"
            className="blueBrand"
            target="_blank"
            href="https://financialaid.arizona.edu/types-of-aid/scholarships/incoming-first-year-transfer?utm_source=Multipage&utm_medium=Print&utm_campaign=Apply%20Now"
          >
            Arizona Tuition Award merit chart
          </a>
          . These awards are subject to available funding.
        </p>
      </div>
    </div>
  )
}

export default OOSSemi
